<template>

  <div class="feedItem panel bg-lightest black">
    <div class="w-100 font-weight-600"><span class="ml-1">Occupancy Report</span></div>
    <div class="px-0 py-5 w-100" v-if="!errorNoData">
      <div class="w-50 m-auto">
        <v-select label="name" placeholder="Products" v-model="selectedEventName" :on-change="changeDataset" :options="listEventNames"></v-select>
      </div>
      <div class="w-100 pt-4">
        <occupancy :height="100" :chartData="stackBarsData"></occupancy>
      </div>
    </div>

    <div v-else class="px-0 py-5 w-100 text-center font-weight-600 medium fs-larger">
      No data
    </div>
  </div>

</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  import extendedVSelect from '@/extends/vue-select'
  import Occupancy from '../../tools/charts/Occupancy.js'

  export default {
    created: function() {
      // *******************************
      // Requests API for today's events
      // needs to be changed for today only, not the month
      // testing
      // *******************************

      this.loadEvents(
        moment(new Date).startOf('day').format('YYYY-MM-DD'),
        moment(new Date).endOf('day').format('YYYY-MM-DD')
      );


    },
    data: function() {
      return {
        errorNoData: true,
        stackBarsData: {},
        todayEvents: {},
        selectedEventName: null
      }
    },
    props: {
      cardInfo: {
        type: Object
      }
    },
    computed: {
      ...mapGetters([
        'account',
      ]),
      listEventNames: function() {
        var namesArray = [];

        for (var eventName in this.todayEvents) {
          if (this.todayEvents.hasOwnProperty(eventName)) {
            namesArray.push(eventName);
          }
        }

        return namesArray;
      },
      selectedEventNameDataset: function() {
        var hoursArr = [];
        var bookedArr = [];
        var availableArr = [];
        var percetArr = [];
        var percentRemainingArr = [];
        var colorArr = [];
        var tooltipArr = [];

        var todayEvents = this.todayEvents;
        var selectedEventName = this.selectedEventName;

        for (var i = 0; i < todayEvents[selectedEventName].length; i++) {
          hoursArr.push(todayEvents[selectedEventName][i].startHour);
          bookedArr.push(todayEvents[selectedEventName][i].booked);
          availableArr.push(todayEvents[selectedEventName][i].available);
          percetArr.push(todayEvents[selectedEventName][i].percent);
          percentRemainingArr.push(todayEvents[selectedEventName][i].percentRemaining);
          colorArr.push(todayEvents[selectedEventName][i].color);
          tooltipArr.push(todayEvents[selectedEventName][i].tooltip);
        }

        return {
          hours: hoursArr,
          booked: bookedArr,
          available: availableArr,
          percet: percetArr,
          percentRemaining: percentRemainingArr,
          color: colorArr,
          tooltip: tooltipArr
        };
      }
    },
    methods: {
      ...mapActions([
        'refreshAccountData'
      ]),
      changeDataset: function(e) {

        // if item is deselected form the dropdown
        if (e == 'null') {
          this.selectedEventName = Object.keys(this.todayEvents)[0];
          return false;
        }

        // see this for reactive update: https://codepen.io/apertureless/pen/BZKBdX?editors=1010
        this.fillData(
            [this.todayEvents[e][0].startHour],
            [this.todayEvents[e][0].color],
            [this.todayEvents[e][0].percent],
            [this.todayEvents[e][0].percentRemaining],
            [this.todayEvents[e][0].tooltip]
        );

      },
      fillData: function(labelsArr, colorArr, datasetArr, compDatasetArr, tooltip) {
        //compDatasetArr is the grey part of the graph. i.e.: dataset val is 25 the compDatasetArr val is 75.
        this.stackBarsData = {
          labels: labelsArr,
          datasets: [{
              label: 'Booked',
              backgroundColor: colorArr,
              data: datasetArr
            },
            {
              label: 'Available',
              backgroundColor: '#e6eaee',
              data: compDatasetArr
            },
            {
              data: tooltip,
              hidden: true,
            }
          ],
        }
      },
      complementaryDataset: function(dataset) {
        var compDataset = [];

        for (var i = 0; i < dataset.length; i++) {
          compDataset.push(100 - dataset[i])
        }

        return compDataset
      },
      async loadEvents(start, end) {
        try {
          //await this.refreshAccountData();

          let response = await axios.get('api/calendar/GetEvents', {
            params: {
              supplierId: this.account.supplierId,
              dateFrom: start,
              dateTo: end
            }
          });

          if (response && response.status === 200) {
            this.selectedEventName = response.data.events[0].product.name; //sets the selectedEventName for the dropdown
            this.populateCard(response.data.events);
            this.errorNoData = false;
          }
        } catch (error) {

        }
      },
      populateCard: function(eventsArr) {
        var namesArray = [];
        var dataObj = {};
        var redTreshold = 80; //percent to make the bar red instead of blue.
        var colorRed = '#e73f47';
        var colorBlue = '#6EC8EE';

        // create array  with eventNames
        for (let singleEvent of eventsArr) {
          let eventName = singleEvent.product.name;
          let startHour = moment(singleEvent.start).format('H:mm');
          let endHour = moment(singleEvent.end).format('H:mm');
          let lotation = singleEvent.maximumLotation;
          let available = singleEvent.quantityAvailable;
          let booked = (lotation == 0) ? lotation : lotation - available;
          //let percent           = (lotation == 0) ? 100 : ((available / lotation) - 1) * 100;
          let percent = (lotation == 0) ? 100 : ((lotation - available) / 100) * 100;
          let percentRemaining = 100 - percent;
          let color = (percent >= redTreshold) ? colorRed : colorBlue;
          let tooltip = (lotation == 0) ? 'Private' : 'Bookings: ' + booked;

          if (typeof dataObj[eventName] == 'undefined') {
            dataObj[eventName] = [];
          }

          dataObj[eventName].push({
            'startHour': startHour,
            'endHour': endHour,
            'lotation': lotation,
            'available': available,
            'booked': booked,
            'percent': percent,
            'percentRemaining': percentRemaining,
            'color': color,
            'tooltip': tooltip
          });

        }

        this.todayEvents = dataObj;

      }
    },
    components: {
      vSelect: extendedVSelect,
      Occupancy
    }
  }
</script>

<style scoped lang="scss">
  @import '../../assets/scss/_variables.scss';


  .panel {
    height: auto !important;
  }

  .ticketGraph {
    width: 59px;
    height: 110px;

  }
</style>



// WEBPACK FOOTER //
// FeedcardOccupancyReport.vue?cc0f0ab4